import React from "react";
import {
  Box,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell as MuiTableCell,
  TableBody,
  Paper,
  Typography,
  styled,
  Stack,
} from "@mui/material";
import copyrightData from "../../utils/copyrights.json"; // Import the data

type Copyright = {
  srNo: number;
  title: string;
  nameOfTeacher: string;
  registrationNo: string;
  yearOfPublishing: string; // Change to string to accommodate date format
};

const TableCell = styled(MuiTableCell)(({ theme }) => ({
  fontSize: 16,
  textAlign: "left",
  color: theme.palette.primary.contrastText,
  wordBreak: "break-word", // Ensure long words break to fit the column width
}));

function formatDate(dateString: string): string {
  const [year, month, day] = dateString.split("-");
  return `${day}/${month}/${year}`;
}

function Copyrights() {
  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
        spacing={2}
      >
        <Typography
          variant="h6"
          sx={{
            p: 2,
            backgroundColor: "primary.main",
            color: "white",
            width: "100%",
            textAlign: "center",
            fontWeight: "bold",
          }}
        >
          Copyrights
        </Typography>
        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">Sr. No</TableCell>
                <TableCell align="center" sx={{ width: "30%" }}>Title</TableCell>
                <TableCell align="center">Name of Teacher</TableCell>
                <TableCell align="center">Registration No</TableCell>
                <TableCell align="center">Year of Publishing</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {copyrightData?.length > 0 ? (
                copyrightData.map((item) => (
                  <TableRow key={item.srNo}>
                    <TableCell align="center">{item.srNo}</TableCell>
                    <TableCell align="center" sx={{ width: "30%" }}>{item.title}</TableCell>
                    <TableCell align="center">
                      {item.nameOfTeacher.split(", ").map((name, index) => (
                        <Typography key={index} variant="body2" sx={{ fontSize: 16 }}>
                          {name}
                        </Typography>
                      ))}
                    </TableCell>
                    <TableCell align="center">{item.registrationNo}</TableCell>
                    <TableCell align="center">
                      {formatDate(item.yearOfPublishing.toString())}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow sx={{ textAlign: "center" }}>
                  <TableCell
                    colSpan={7}
                    align="center"
                    style={{ textAlign: "center" }}
                  >
                    {"No data Found!"}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </Box>
  );
}

export default Copyrights;
